import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import SectionHeading from "@/components/common/SectionHeading";
import FormationCard from "@/components/common/FormationCard";
import { FORMATIONS } from "@/data/formations";

const FEATURED = [
  "tp-ecsr",
  "permis-c",
  "permis-d",
  "permis-ce",
  "ccs-2-roues",
  "ccs-groupe-lourd",
  "fimo-marchandises",
  "fco-voyageurs",
];

export default function FormationsPreview() {
  const list = FEATURED.map((s) => FORMATIONS.find((f) => f.slug === s)).filter(Boolean);
  return (
    <section className="bg-slate-50/60 py-24 lg:py-32" data-testid="formations-preview">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <SectionHeading
            eyebrow="Nos formations"
            title="Des parcours certifiants pour chaque métier"
          />
          <Button
            asChild
            variant="outline"
            className="rounded-full border-2 border-brand-blue px-6 text-brand-blue hover:bg-brand-blue hover:text-white"
            data-testid="formations-preview-all"
          >
            <Link to="/nos-formations">Toutes les formations</Link>
          </Button>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((f, i) => (
            <FormationCard key={f.slug} formation={f} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
